import { Editor } from '@tiptap/react'
import { Flex } from 'antd'

import { ImageButton } from './ImageButton'
import { YouTubeButton } from './YouTubeButton'

type Props = {
  editor: Editor
  enableImageModal?: boolean
}

export const MenuMediaButtons = ({ editor, enableImageModal }: Props) => {
  return (
    <Flex gap="8px">
      {enableImageModal && <ImageButton editor={editor} />}

      <YouTubeButton editor={editor} />
    </Flex>
  )
}
